<template>
  <canvas
    :id="`screenCap-${pageNumber}`"
    v-bind="overlayAttributesSimple"
    :class="{ screenShotCanvas: true, screenShot: isScreenCapEnabled, 'overlay-page': true }"
    @mousedown="mouseDown($event)"
    @mouseup="mouseUp($event)"
    @mousemove="mouseMove($event)"
  ></canvas>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'ScreenCapCanvas',
  data() {
    return {
      isCleared: true
    };
  },
  props: {
    overlayAttributesSimple: {
      type: Object,
      required: true
    },
    pageNumber: {
      pageNumber: Number,
      required: true
    },
    scale: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState('components/pdfViewer', [
      'startDrag',
      'currentDrag',
      'finalShape',
      'isScreenCapEnabled'
    ])
  },
  methods: {
    ...mapMutations('components/pdfViewer', [
      'setStartDrag',
      'setCurrentDrag',
      'setFinalShape',
      'setCaptureCurrent',
      'setCapturedImage'
    ]),
    clearScreenShotCanvas() {
      const screenShotCanvas = this.$el;
      const ctx = screenShotCanvas.getContext('2d');
      ctx.clearRect(0, 0, screenShotCanvas.width, screenShotCanvas.height);
      ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
      ctx.rect(0, 0, screenShotCanvas.width, screenShotCanvas.height);
      ctx.fill();
      this.isCleared = true;
    },
    drawSelection(input) {
      const { minX, minY, width, height } = input;
      const screenShotCanvas = this.$el;
      const ctx = screenShotCanvas.getContext('2d');
      this.clearScreenShotCanvas();
      ctx.strokeStyle = 'lightblue';
      ctx.strokeWidth = 3;
      ctx.clearRect(minX, minY, width, height);
      ctx.strokeRect(minX, minY, width, height);
      this.isCleared = false;
    },
    mouseDown(event) {
      console.log('mouseDown', event);
      this.clearScreenShotCanvas();
      const startDrag = { x: event.offsetX, y: event.offsetY, page: this.pageNumber };
      this.setStartDrag(startDrag);
      this.setCapturedImage(null);
    },
    mouseUp(event) {
      const currentDrag = { x: event.offsetX, y: event.offsetY, page: this.pageNumber };
      const down = this.startDrag;
      const distance = distanceCalc(down, currentDrag);
      if (distance < 10 || currentDrag.page !== this.startDrag.page) {
        this.clearScreenShotCanvas();
        this.setFinalShape({});
      } else {
        const finalShape = {};
        finalShape.minY = Math.min(currentDrag.y, down.y);
        finalShape.minX = Math.min(currentDrag.x, down.x);
        finalShape.width = Math.abs(currentDrag.x - down.x);
        finalShape.height = Math.abs(currentDrag.y - down.y);
        finalShape.page = this.pageNumber;
        this.setFinalShape(finalShape);
        this.setCaptureCurrent(true);
      }
      this.setStartDrag({});
    },
    mouseMove(event) {
      const down = this.startDrag;
      if ('x' in down && down.page === this.pageNumber) {
        let currentDrag = { x: event.offsetX, y: event.offsetY };
        const finalShape = {};
        finalShape.minY = Math.min(currentDrag.y, down.y);
        finalShape.minX = Math.min(currentDrag.x, down.x);
        finalShape.width = Math.abs(currentDrag.x - down.x);
        finalShape.height = Math.abs(currentDrag.y - down.y);
        finalShape.page = this.pageNumber;
        this.setFinalShape(finalShape);
      }
    }
  },
  watch: {
    finalShape(val) {
      if ('page' in val) {
        if (val.page !== this.pageNumber && !this.isCleared) {
          this.clearScreenShotCanvas();
        } else {
          if (val.page === this.pageNumber) {
            this.drawSelection(val);
          }
        }
      } else if (!this.isCleared) {
        this.clearScreenShotCanvas();
      }
    },
    overlayAttributesSimple() {
      this.$nextTick(() => {
        this.clearScreenShotCanvas();
      });
    }
  },
  mounted() {
    this.clearScreenShotCanvas();
  }
};

function distanceCalc(point1, point2) {
  const x2 = Math.pow(point1.x - point2.x, 2);
  const y2 = Math.pow(point1.y - point2.y, 2);
  const dist = Math.pow(x2 + y2, 0.5);
  return dist;
}
</script>
<style scoped>
.screenShotCanvas {
  opacity: 0;
}
.screenShotCanvas:hover {
  cursor: crosshair;
}

.screenShotCanvas.screenShot {
  opacity: 1;
}
</style>
